<!--
 * @Author: your name
 * @Date: 2022-04-19 15:45:49
 * @LastEditTime: 2022-04-28 14:43:34
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/mall/index.vue
-->
<template>
  <div class="order">
    <div class="head">
      <div class="head_img">
        <img src="../../static/image/positions.png" />
      </div>
      <div class="head_con">
        <p class="con_address">{{ adress.addressDesc }}</p>
        <p class="con_name">
          {{ adress.contactName }} {{ adress.contactPhone }}
        </p>
      </div>
    </div>
    <div class="goods_list">
      <div class="list_title">
        商品信息
      </div>
      <div class="list_item" v-for="(item, index) in list" :key="index">
        <div class="item_img">
          <img
            :src="
              item.goodsImageUrl
                ? item.goodsImageUrl
                : '../../static/image/bgimg.png'
            "
          />
        </div>
        <div class="item_center">
          <p class="center_tit">{{ item.goodsName }}</p>
          <p class="center_price">
            ￥{{ item.goodsPrice }} <span>x{{ item.goodsNumber }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="distribution">
      <p class="distribution_tit">配送费</p>
      <p class="distribution_content">￥{{ saleTempInfo.deliveryCost || 0 }}</p>
    </div>
    <div class="distribution">
      <p class="distribution_tit">配送说明</p>
      <p class="distribution_content">{{ saleTempInfo.deliveryDesc }}</p>
    </div>
    <div class="distribution">
      <p class="distribution_tit">合计</p>
      <p class="distribution_totle">￥{{ saleTempInfo.amount }}</p>
    </div>
    <div class="distribution">
      <p class="distribution_tit"></p>
      <a :href="`tel:${shopData.tel}`" class="callShop">联系商家</a>
    </div>
    <!-- <Return></Return> -->
  </div>
</template>
<script>
export default {
  name: "Detail",
  data() {
    return {
      adress: {},
      saleTempInfo: {},
      list: [],
      shopData: JSON.parse(localStorage.getItem("shopList"))[0]
    };
  },
  mounted() {
    const data = JSON.parse(decodeURIComponent(this.$route.query.detail));
    this.saleTempInfo = data;
    console.log(data, "ddddddddddd");
    this.adress = data.addressInfo;
    this.list = data.goodsList;
  },
  methods: {}
};
</script>
<style scoped>
.order {
  font-size: 8px;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  background: rgba(245, 245, 245, 0.39);
}
.head {
  width: 100%;
  height: 61px;
  background: #ffffff;
  display: flex;
  justify-content: start;
  box-sizing: border-box;
  padding: 18px;
  border-top: solid 0.5px #757575;
}
.head_con {
  margin-left: 12px;
}
.head_img {
  width: 25px;
  height: 25px;
  margin-top: 4px;
}
.head_img img {
  border-radius: 50px;
  width: 100%;
  height: 100%;
}
.head_href {
  height: 25px;
  line-height: 1;
  margin-top: 10px;
}
.head_href img {
  height: 13px;
}
.con_address {
  font-size: 11px;
  font-weight: 500;
  color: #212121;
}
.con_name {
  font-size: 10px;
  color: #757575;
  margin-top: 4px;
}
.set_con {
  font-size: 11px;
  color: #e0e0e0;
  height: 35px;
  line-height: 35px;
  margin-left: 40px;
}
.goods_list {
  background: #ffffff;
  margin-top: 5px;
}
.list_item {
  width: 100%;
  height: 73px;
  background: white;
  /* border: solid 1px; */
  box-sizing: border-box;
  padding: 11px 11px 0 11px;
  display: flex;
  position: relative;
  justify-content: flex-start;
}
.item_img {
  width: 50px;
  height: 50px;
}
.item_img img {
  width: 100%;
  height: 100%;
}
.item_center {
  width: calc(100% - 65px);
  overflow: hidden;
  margin-left: 11px;
  margin-top: 10px;
}
.center_tit {
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #757575;
}

.center_price {
  font-size: 11px;
  line-height: 12px;
  color: #fe6262;
  margin-top: 11px;
  position: relative;
}
.center_price span {
  position: absolute;
  right: 0;
  font-size: 8px;
  color: #757575;
}
.list_title {
  font-size: 10px;
  color: #212121;
  padding: 11px 0 0 11px;
}
.distribution {
  width: 100%;
  background: #ffffff;
  box-sizing: border-box;
  padding: 0 11px;
  height: 25px;
  line-height: 25px;
  display: flex;
  color: #212121;
  font-size: 8px;
  justify-content: space-between;
}
.distribution_tit {
  font-size: 8px;
  color: #757575;
}
.distribution_totle {
  font-size: 11px;
  color: #fe6262;
}
.callShop {
  width: 50px;
  height: 17px;
  line-height: 17px;
  text-align: center;
  background: rgba(238, 238, 238, 0.39);
  opacity: 1;
  border-radius: 10px;
  color: #757575;

  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/orderDetail/index.vue